var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvancedTeachnologyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Advanced Teachnology icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62 27H7C4.23858 27 2 29.2386 2 32V62C2 64.7614 4.23858 67 7 67H62C64.7614 67 67 64.7614 67 62V32C67 29.2386 64.7614 27 62 27Z",
    stroke: "black",
    strokeWidth: 2.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.5 27V2",
    stroke: "black",
    strokeWidth: 2.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.5 54.5C53.6421 54.5 57 51.1421 57 47C57 42.8579 53.6421 39.5 49.5 39.5C45.3579 39.5 42 42.8579 42 47C42 51.1421 45.3579 54.5 49.5 54.5Z",
    stroke: "black",
    strokeWidth: 2.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.5 54.5C23.6421 54.5 27 51.1421 27 47C27 42.8579 23.6421 39.5 19.5 39.5C15.3579 39.5 12 42.8579 12 47C12 51.1421 15.3579 54.5 19.5 54.5Z",
    stroke: "black",
    strokeWidth: 2.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedTeachnologyicon);
export default __webpack_public_path__ + "static/media/Advanced Teachnology icon.4ac456875e6ec47288bb6b2b6e929b7b.svg";
export { ForwardRef as ReactComponent };